export const NUMBER_OF_TOMS = 4;

// figure it out from the division  Division is number of notes per measure 4, 6, 8, 12, 16, 24, 32, etc...
// Triplets only support 4/4 and 2/4 time signatures for now
export function isTripletDivision(division: number): boolean {
  // we only support 12 & 24 & 48  1/8th, 1/16, & 1/32 note triplets
  return division % 12 === 0;
}

// figure out if it is triplets from the number of notes (implied division)
export function isTripletDivisionFromNotesPerMeasure(
  notesPerMeasure: number,
  timeSigTop: number,
  timeSigBottom: number,
): boolean {
  const division = notesPerMeasure / timeSigTop * timeSigBottom;

  return isTripletDivision(division);
}



// WEBPACK FOOTER //
// ./src/utils.tsx